export default {
    newUser: 'New User',
    editUser: 'Edit User',

    name: 'Name',
    email: 'Email',
    role: 'Role',
    createdAt: 'Created date',
    password: 'Password',
    passwordConfirm: 'Password confirm',

    form: {
        name: {
            label: 'Name',
            placeholder: 'Insert name',
        },
        email: {
            label: 'Email',
            placeholder: 'Insert email',
        },
        role: {
            label: 'Role',
            placeholder: 'Select role',
        },
        createdAt: {
            label: 'Created date',
            placeholder: '',
        },
        password: {
            label: 'Password',
            placeholder: 'Insert password',
        },
        passwordConfirm: {
            label: 'Confirm Password',
            placeholder: 'Insert confirm password',
        },

        mock: 'Mock',
        reset: 'Cancel',
        submit: 'Save',
    },

    modals: {
        remove: {
            text: 'Do you want to remove this user?',
        },
        removeSuccess: {
            title: 'Great!',
            text: 'User removed successfully.',
        },
        createdSuccess: {
            title: 'Great!',
            text: 'User created successfully.',
        },
        updatedSuccess: {
            title: 'Great!',
            text: 'User updated successfully.',
        },
    },
}
